"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableTilesOnEnd = exports.disableTilesOnStart = void 0;
var date_fns_1 = require("date-fns");
var today = new Date();
exports.disableTilesOnStart = function (_a) {
    var date = _a.date, view = _a.view;
    if (view === 'month') {
        var isFutureMonth = date_fns_1.isAfter(date, date_fns_1.lastDayOfMonth(today));
        return !date_fns_1.isFirstDayOfMonth(date) || isFutureMonth;
    }
    return false;
};
exports.disableTilesOnEnd = function (_a) {
    var date = _a.date, view = _a.view;
    if (view === 'month') {
        var isFutureMonth = date_fns_1.isAfter(date, date_fns_1.lastDayOfMonth(today));
        return !date_fns_1.isLastDayOfMonth(date) || isFutureMonth;
    }
    return false;
};
